import Splide from '@splidejs/splide'

export default function Sliders() {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

	// --- Banner Slider ---
	const bannerElements = document.querySelector('.js-banner-slider')
	if (bannerElements) {
		const banner = new Splide('.js-banner-slider', {
			type: 'loop',
			arrows: true,
			pagination: false,
			keyboard: 'focused',
			drag: true,
			rewind: true,
			// Respect prefers-reduced-motion: no auto-advance (WCAG 2.3.3 / 2.2.2).
			autoplay: !prefersReducedMotion,
			speed: 1000,
			interval: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
			snap: true,
			autoHeight: true,
			classes: {
				arrows: 'splide__arrows',
				arrow: 'splide__arrow',
				prev: 'splide__arrow--prev',
				next: 'splide__arrow--next',
			},
		})

		banner.mount()

		// Give the autoplaying hero an accessible pause/play control (WCAG 2.2.2).
		if (!prefersReducedMotion) {
			addAutoplayToggle(banner)
		}
	}

	// --- USP Slider ---
	const uspElements = document.querySelector('.js-usp-slider')
	uspElements && new Splide('.js-usp-slider', {
		type: 'slide',
		perPage: 1,
		perMove: 1,
		pagination: false,
		gap: 20,
		arrows: false,
		mediaQuery: 'min',
		breakpoints: {
			767: {
				perPage: 2,
			},
			1023: {
				perPage: 3,
			},
			1439: {
				perPage: 4,
			},
		},
	}).mount()

	// --- Logos Slider ---
	// Manual carousel: no autoplay, so there's no auto-motion to pause
	// (WCAG 2.2.2 doesn't apply) — users move it with the keyboard-operable
	// prev/next arrows in the markup. Under reduced motion / no JS we don't
	// mount; CSS then shows a static wrapping grid (see _logos.scss) so every
	// logo/link stays visible with no motion at all.
	const logosElements = document.querySelectorAll('.js-logo-slider')
	if (logosElements && !prefersReducedMotion) {
		logosElements.forEach((element) => {
			new Splide(element, {
				type: 'slide',
				perPage: 1,
				perMove: 1,
				gap: 20,
				pagination: false,
				arrows: true,
				mediaQuery: 'min',
				label: 'Partner logos',
				breakpoints: {
					450: {
						perPage: 2,
					},
					767: {
						perPage: 3,
						gap: 40,
					},
					1023: {
						perPage: 4,
					},
					// 1279: {
					// 	perPage: 6,
					// },
				},
				classes: {
					arrows: 'splide__arrows',
					arrow: 'splide__arrow',
					prev: 'splide__arrow--prev',
					next: 'splide__arrow--next',
				},
			}).mount()
		});
	}

	// --- Product Feed Sliders ---
	const productFeed = document.querySelectorAll('.js-product-slider')
	for (let i = 0; i < productFeed.length; i++) {
		new Splide(productFeed[i], {
			type: 'slide',
			perPage: 1,
			perMove: 1,
			gap: 20,
			pagination: false,
			arrows: true,
			mediaQuery: 'min',
			autoplay: false,
			breakpoints: {
				767: {
					perPage: 2,
				},
				1023: {
					perPage: 3,
				},
				1279: {
					perPage: 5,
				},
			},
			classes: {
				arrows: 'splide__arrows',
				arrow: 'splide__arrow',
				prev: 'splide__arrow--prev',
				next: 'splide__arrow--next',
			},
		}).mount()
	}

	// Append a keyboard-operable pause/play button so autoplaying content can
	// be stopped (WCAG 2.2.2). By default it joins an existing arrows bar
	// (banner); pass createContainer to build a standalone control bar for
	// sliders that have no arrows (logos).
	function addAutoplayToggle(splide, options = {}) {
		const Autoplay = splide.Components.Autoplay
		if (!Autoplay) return

		let container = splide.root.querySelector('.splide__arrows')

		if (!container && options.createContainer) {
			container = document.createElement('div')
			container.className = options.containerClass || 'u-flex u-h-center u-mt'
			splide.root.appendChild(container)
		}

		if (!container) return

		const button = document.createElement('button')
		button.type = 'button'
		button.className = options.buttonClass || 'e-slider-arrow e-slider-arrow--white u-ml-half js-slider-pause'
		button.innerHTML = '<ion-icon name="pause-sharp" aria-hidden="true"></ion-icon>'

		let playing = true
		const sync = () => {
			button.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow')
			button.querySelector('ion-icon').setAttribute('name', playing ? 'pause-sharp' : 'play-sharp')
		}
		sync()

		button.addEventListener('click', () => {
			playing = !playing
			playing ? Autoplay.play() : Autoplay.pause()
			sync()
		})

		container.appendChild(button)
	}
}
